export default
{
  InternalRegulations: [],
  InternalRegulation: {},
}
